var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCalendarIcon(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.4133 18.292C23.4133 21.0623 21.1675 23.3089 18.3957 23.3089C15.6248 23.3089 13.3789 21.0623 13.3789 18.292C13.3789 15.521 15.6248 13.2744 18.3957 13.2744C21.1675 13.2744 23.4133 15.521 23.4133 18.292Z",
    stroke: "#4E4E4E",
    strokeWidth: 1.10666
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20.4973 18.9894L18.1484 19.0089L18.1484 15.6416",
    stroke: "#FFB502",
    strokeWidth: 0.737774,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M6 0.856445V5.14216",
    stroke: "#4E4E4E",
    strokeWidth: 1.10666,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M14.9989 0.856445V5.14216",
    stroke: "#4E4E4E",
    strokeWidth: 1.10666,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M1.58594 7.05541H19.2924",
    stroke: "#4E4E4E",
    strokeWidth: 1.10666
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M19.2924 13.1535V5.10916C19.2924 3.9435 18.4504 3 17.4116 3H3.46681C2.42794 3 1.58594 3.9435 1.58594 5.10916V17.8597C1.58594 19.0254 2.42794 19.9689 3.46681 19.9689H12.8567",
    stroke: "#4E4E4E",
    strokeWidth: 1.10666,
    strokeLinecap: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.15317 11.9044C6.15317 12.4049 5.74667 12.8114 5.24687 12.8114C4.74562 12.8114 4.33984 12.4049 4.33984 11.9044C4.33984 11.4045 4.74562 10.998 5.24687 10.998C5.74667 10.998 6.15317 11.4045 6.15317 11.9044Z",
    fill: "#4E4E4E"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.2313 11.9044C11.2313 12.4049 10.8255 12.8114 10.325 12.8114C9.82447 12.8114 9.41797 12.4049 9.41797 11.9044C9.41797 11.4045 9.82447 10.998 10.325 10.998C10.8255 10.998 11.2313 11.4045 11.2313 11.9044Z",
    fill: "#4E4E4E"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.3048 11.9044C16.3048 12.4049 15.899 12.8114 15.3985 12.8114C14.898 12.8114 14.4922 12.4049 14.4922 11.9044C14.4922 11.4045 14.898 10.998 15.3985 10.998C15.899 10.998 16.3048 11.4045 16.3048 11.9044Z",
    fill: "#4E4E4E"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.15317 16.2569C6.15317 16.7574 5.74667 17.1639 5.24687 17.1639C4.74562 17.1639 4.33984 16.7574 4.33984 16.2569C4.33984 15.7571 4.74562 15.3506 5.24687 15.3506C5.74667 15.3506 6.15317 15.7571 6.15317 16.2569Z",
    fill: "#4E4E4E"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.2313 16.2569C11.2313 16.7574 10.8255 17.1639 10.325 17.1639C9.82447 17.1639 9.41797 16.7574 9.41797 16.2569C9.41797 15.7571 9.82447 15.3506 10.325 15.3506C10.8255 15.3506 11.2313 15.7571 11.2313 16.2569Z",
    fill: "#4E4E4E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendarIcon);
export default __webpack_public_path__ + "static/media/Calendar-icon.214975bcf0b5c7d27563ce02c26e5297.svg";
export { ForwardRef as ReactComponent };